import React from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

/**
 * CategoryFilter - Pure UI component voor category filtering
 * Alle logica blijft in de parent component voor veiligheid
 */
const CategoryFilter = ({
	// Display state
	isExpanded,
	selectedCategory,
	categoryFilterMode,
	availableCategories,
	hiddenMachineRecipes,
	
	// Event handlers (blijven in parent)
	onToggleExpanded,
	onCategoryChange,
	onFilterModeChange,
	onClearFilter
}) => {
	return (
		<div>
			{/* Category Filter */}
			<div className="category-filter">
				<div 
					className="filter-trigger" 
					onClick={onToggleExpanded}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault();
							onToggleExpanded();
						}
					}}
					role="button"
					tabIndex={0}
					aria-expanded={isExpanded}
					aria-label="Toggle category filter"
				>
					<div className="filter-trigger-content">
						<div className="filter-trigger-left">
							<i className="pi pi-tag filter-trigger-icon"></i>
							<span className="filter-trigger-text">Category Filter</span>
							{selectedCategory && (
								<div className="filter-badge filter-badge--category">
									{selectedCategory}
								</div>
							)}
						</div>
						<div className="filter-trigger-right">
							{selectedCategory && (
								<Button
									icon="pi pi-times"
									text
									size="small"
									onClick={(e) => {
										e.stopPropagation();
										onClearFilter();
									}}
									className="clear-category-filter-btn"
									aria-label="Clear category filter"
								/>
							)}
							<i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'} chevron-icon`}></i>
						</div>
					</div>
				</div>

				{isExpanded && (
					<div className="category-filter-content">
						<div className="filter-controls">
							<div className="filter-group">
								<label htmlFor="categoryFilter" className="filter-label">Category</label>
								<Dropdown
									id="categoryFilter"
									value={selectedCategory}
									options={[
										{ label: 'All categories', value: '' },
										...availableCategories.map(category => ({
											label: category.charAt(0).toUpperCase() + category.slice(1).toLowerCase(),
											value: category
										}))
									]}
									onChange={onCategoryChange}
									placeholder="Select category..."
									className="modern-dropdown"
								/>
							</div>
							
							{selectedCategory && (
								<div className="filter-group">
									<label htmlFor="filterMode" className="filter-label">Mode</label>
									<Dropdown
										id="filterMode"
										value={categoryFilterMode}
										options={[
											{ label: 'Include only', value: 'include' },
											{ label: 'Exclude', value: 'exclude' }
										]}
										onChange={onFilterModeChange}
										className="modern-dropdown"
									/>
								</div>
							)}
						</div>

						{selectedCategory && (
							<div className="category-filter-status">
								<div className="status-indicator">
									<i className={`pi ${categoryFilterMode === 'include' ? 'pi-check' : 'pi-ban'} status-icon`}></i>
									<span className="status-text">
										{categoryFilterMode === 'include' ? 'Showing' : 'Hiding'} recipes with <b>{selectedCategory}</b> category
									</span>
								</div>
							</div>
						)}
					</div>
				)}
			</div>

			{/* Info Card voor filtered recipes */}
			{selectedCategory && hiddenMachineRecipes.length > 0 && (
				<div className="info-card">
					<div className="info-content">
						<div className="info-icon-wrapper">
							<i className="pi pi-eye-slash info-icon"></i>
						</div>
						<div className="info-text">
							<span className="info-title">
								{hiddenMachineRecipes.length} recipe{hiddenMachineRecipes.length === 1 ? '' : 's'} dimmed
							</span>
							<span className="info-description">
								Recipe{hiddenMachineRecipes.length === 1 ? '' : 's'} {categoryFilterMode === 'include' ? 'without' : 'with'} <b>{selectedCategory}</b> category {hiddenMachineRecipes.length === 1 ? 'is' : 'are'} shown with reduced opacity
							</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default CategoryFilter;
